import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button, SubmitButton } from "@/components/Interface/Button/Button";
import { ProfileCard } from "@/components/Layout/BaseLayouts/ProfileCard/ProfileCard";
import { OrSeparator } from "@/components/Layout/OrSeparator";
import { TwoFactorAppAlternatives } from "@/components/Portal/UserAccount/Security/Change/TwoFactorAppAlternatives";
import { TwoFactorQRCodeSection } from "@/components/Portal/UserAccount/Security/Change/TwoFactorQrCodeSection";
import { AuthenticatorSetupMethodsForm } from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSetupForm";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

export const TwoFactorChangeAppView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { handleSubmit, watch, setValue } =
    useForm<AuthenticatorSetupMethodsForm>();

  const watchType = watch("type");

  const onSubmit = (data: AuthenticatorSetupMethodsForm) => {
    if (data.type === ChangeTwoFactorAuthenticationMethod.SMS) {
      navigate(portalRoutes.user.security.setup2faSms);
    }

    if (data.type === ChangeTwoFactorAuthenticationMethod.STANDARD) {
      navigate(portalRoutes.user.security.confirmStandard);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ProfileCard
        maxWidth="none"
        title={t("portal:user-account.security.2fa.initialSetup.title")}
        actions={
          <>
            <Button
              variant="secondary"
              size="sm"
              type="button"
              onClick={() => navigate(portalRoutes.user.security.base)}
            >
              {t("portal:user-account.security.buttons.back")}
            </Button>
            <SubmitButton
              fullWidth={false}
              size="sm"
              label={t("portal:authenticator.sms.verification.finishSetup")}
              disabled={!watchType}
            />
          </>
        }
      >
        <TwoFactorQRCodeSection />
        <OrSeparator />
        <TwoFactorAppAlternatives
          value={watchType ?? null}
          onChange={(type) => setValue("type", type)}
        />
      </ProfileCard>
    </form>
  );
};
